import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { EMSP_BO_INVOICE_LIST_COLUMN_LABEL_I18N_KEY } from '../emsp-bo-invoice-list/emsp-bo-invoice-list.config';
import { useEmspBoInvoiceListContext } from '../emsp-bo-invoice.context';

export const EmspBoInvoiceListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useEmspBoInvoiceListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={EMSP_BO_INVOICE_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
